import { render, staticRenderFns } from "./CreateProject.yaml?vue&type=template&id=4b72932d&component"
import script from "./CreateProject.yaml?vue&type=script&lang=ts&component"
export * from "./CreateProject.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports